import {
  FieldMappingPhoneField,
  FieldMappingPhoneFieldProps,
} from '@components/field-mapping-phone-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingPhoneFieldProps<T = unknown> = FormFieldProps<
  FieldMappingPhoneFieldProps,
  T
>;

export function FormFieldMappingPhoneField<T>(props: FormFieldMappingPhoneFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <FieldMappingPhoneField {...props} {...formFieldProps} />;
}
